ComponentRegistry.register(function ($context) {
    return $context.find('.range')
}, function ($range) {
    $range.find('.range__link--childs').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var button = $(this);
        var listItem = button.closest('.range__item');
        listItem.siblings().removeClass('range__item--opened');
        listItem.toggleClass('range__item--opened');
        return false;
    });

    $range.find('.range__arrow--open').on('click', function (e) {
        e.stopPropagation();
        var button = $(this);
        var listItem = button.closest('.range__item');
        listItem.siblings().removeClass('range__item--opened');
        listItem.toggleClass('range__item--opened');
        return false;
    });
});
